import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { SliderHorizontalIcon } from '@com/icons';
import useModal from '@hooks/useModal';

import FilterBottomsheet from './FilterBottomsheet';

type FilterProps = {
  categoryCodeLevel1?: string;
  categoryCodeLevel2?: string;
  categoryCodeLevel3?: string;
};

const Filter = ({
  categoryCodeLevel1,
  categoryCodeLevel2,
  categoryCodeLevel3,
}: FilterProps) => {
  const { addModal } = useModal();
  const { query } = useRouter();

  const [filterItemsNumber, setFilterItemsNumber] = useState<number | null>();

  useEffect(() => {
    const brandQuantity = query?.brand ? 1 : 0;
    const shapeQuantity = query?.shapeCode ? 1 : 0;
    const shapeSort = query?.sortName ? 1 : 0;

    setFilterItemsNumber(brandQuantity + shapeQuantity + shapeSort);
  }, [query]);

  const handleFilterModal = () => {
    addModal({
      modal: FilterBottomsheet,
      props: {
        plpQuery: query,
        categoryCodeLevel1,
        categoryCodeLevel2,
        categoryCodeLevel3,
      },
    });
  };

  return (
    <div className="w-max h-8 flex items-center gap-x-2">
      {categoryCodeLevel1 !== '11' && categoryCodeLevel1 !== '15' && (
        <div className="relative w-max h-8 flex items-center gap-x-2">
          {!!filterItemsNumber && (
            <div className="absolute left-0 top-0 h-3 w-3 flex items-center justify-center rounded-full bg-surface-primary">
              <div className="w-2 h-2 bg-surface-negative rounded-full" />
            </div>
          )}

          <div
            className="h-8 px-3 flex items-center rounded-full cursor-pointer bg-surface-tertiary gap-x-2"
            onClick={handleFilterModal}
          >
            <SliderHorizontalIcon width={24} height={24} fill={'black'} />
            <span>فیلتر</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Filter;
